// extracted by mini-css-extract-plugin
export default {"offers":"OffersList_offers__maNH4"};